import { useSelector } from 'react-redux';
import { selectRegionId } from '../selectors/offer';
import { EMultiPostingAvailablePlatforms, IMultiPostingPlatformsByRegion } from '../redux/types/multiPosting/types';
import * as React from 'react';
import { ApplicationContext } from '../components/ApplicationContext';
import { selectMultiPostingAvailablePlatforms } from '../selectors/publishTerms';

export const useMultiPostingDescription = (): string => {
  const { config } = React.useContext(ApplicationContext);
  const availablePlatforms = useSelector(selectMultiPostingAvailablePlatforms);
  const regionId = useSelector(selectRegionId);
  const platformsByRegion = config.get<IMultiPostingPlatformsByRegion>('addformConfig.multiPosting.platforms') || {};
  const regionData = platformsByRegion[String(regionId)];
  const defaultText = String(config.get('addformConfig.multiPosting.text'));

  if (!regionData) {
    return defaultText;
  }

  const { descriptionAll, descriptionFree } = regionData;

  if (availablePlatforms === EMultiPostingAvailablePlatforms.Free && descriptionFree) {
    return descriptionFree;
  } else if (availablePlatforms === EMultiPostingAvailablePlatforms.All && descriptionAll) {
    return descriptionAll;
  }

  return defaultText;
};
